import { NavLink, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const NAV = [
  { to: "/", label: "Accueil", end: true },
  { to: "/approche", label: "Notre approche" },
  { to: "/#contact", label: "Contact", anchor: true },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    // Scroll-to-top on route change, unless a hash anchor is set
    if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [location.pathname, location.hash]);

  // Handle scroll-to-anchor when navigating to /#contact
  useEffect(() => {
    if (location.pathname === "/" && location.hash === "#contact") {
      const el = document.getElementById("contact");
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
      }
    }
  }, [location.pathname, location.hash]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 w-full backdrop-blur-[10px] transition-all duration-500 ${
        scrolled
          ? "bg-cream/92 border-b border-cream-darker shadow-[0_1px_0_rgba(20,39,61,0.04)]"
          : "bg-cream/80 border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-[78px] max-w-[1400px] items-center justify-between px-6 md:px-12 lg:px-16">
        <Link
          to="/"
          data-testid="header-logo"
          className="group flex items-center transition-opacity duration-300 hover:opacity-90"
          aria-label="Gambit Immobilier — Accueil"
        >
          <img
            src="/brand/logo-gambit-tight.svg"
            alt="Gambit Immobilier"
            className="h-[44px] w-auto select-none transition-transform duration-700 ease-out group-hover:scale-[1.02] md:h-[48px]"
            draggable={false}
          />
        </Link>

        <nav aria-label="Navigation principale">
          <ul className="flex items-center gap-7 md:gap-10">
            {NAV.map((item) =>
              item.anchor ? (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    data-testid="nav-contact"
                    className="relative inline-block py-1 text-[13px] tracking-[0.02em] text-ink/80 transition-colors duration-300 hover:text-ink"
                  >
                    {item.label}
                  </Link>
                </li>
              ) : (
                <li key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.end}
                    data-testid={`nav-${item.to === "/" ? "home" : item.to.replace("/", "")}`}
                    className={({ isActive }) =>
                      `relative inline-block py-1 text-[13px] tracking-[0.02em] transition-colors duration-300 ${
                        isActive ? "text-gold" : "text-ink/80 hover:text-ink"
                      }`
                    }
                  >
                    {({ isActive }) => (
                      <span className="relative inline-block">
                        {item.label}
                        <span
                          className={`pointer-events-none absolute left-0 right-0 -bottom-1 h-px origin-left bg-gold transition-transform duration-500 ease-out ${
                            isActive ? "scale-x-100" : "scale-x-0"
                          }`}
                        />
                      </span>
                    )}
                  </NavLink>
                </li>
              )
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}
